import { DashboardWidgetTypes } from '@cloud-twin-v2/ct-dashboards/models/dashboard-widget-types';
import { DashboardChildWidgetParams } from '@common-modules/right-panel/dashboards/dashboard-widget-params';
import { IFiltrableItemDto } from '@common-modules/shared/model/filtrable-items/filtrable-item.dto';
import { IWidgetSettings } from './widget-settings';

export class DashboardCartAndSettings extends DashboardChildWidgetParams {
  dashboardChildId: string;
  widgetType: DashboardWidgetTypes;
  visibleItems: IFiltrableItemDto[] = [];
  items: IFiltrableItemDto[] = [];
  timeStep: Date;
  widgetSettings?: IWidgetSettings;

  constructor(init: DashboardCartAndSettings) {
    super();
    Object.assign(this, init);
  }
}
